import StoryblokLink from "../link/StoryblokLink";
import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic";

import styles from "./bannerPanel.module.scss";

function BannerPanel({desktop_image, mobile_image, link}) {

  if(link) {
    return (
      <StoryblokLink linkObject={link} className={styles.headerBanner}>
        {desktop_image && desktop_image.filename ? <div className={`${styles.desktop} ${mobile_image && mobile_image.filename ? "" : styles.noMobileImage}`}><StoryblokImageBasic image={desktop_image} /></div> : null}
        {mobile_image && mobile_image.filename ? <div className={styles.mobile}><StoryblokImageBasic image={mobile_image} /></div> : null }
      </StoryblokLink>
    )
  } else {
    return (
      <div className={styles.headerBanner}>
        {desktop_image && desktop_image.filename ? <div className={`${styles.desktop} ${mobile_image && mobile_image.filename ? "" : styles.noMobileImage}`}><StoryblokImageBasic image={desktop_image} /></div> : null}
        {mobile_image && mobile_image.filename ? <div className={styles.mobile}><StoryblokImageBasic image={mobile_image} /></div> : null }
      </div>
    )
  }
}

export default BannerPanel
